import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { CircularProgress } from '@gapartners/ui';
import { ROUTES } from '@/constants';

export function RootRedirect() {
  const { isAuthenticated, loading } = useSelector(
    (state: RootState) => state.auth
  );
  console.log('isAuthenticated', isAuthenticated);

  if (loading) {
    return <CircularProgress />;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Navigate to={ROUTES.LOGIN} replace />;
}
